import axios, { AxiosRequestConfig, AxiosResponse } from "axios"

import { API_URL, INSTANCE } from "config"
import { AppStore } from "redux/store"
import TokenService from "redux/api/tokenService"

export const PUBLIC_API = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})

export const setupAxiosInterceptors = (store: AppStore) => {
  axios.defaults.baseURL = API_URL

  axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.headers = {
        ...config.headers,
        "X-INSTANCE": INSTANCE,
      }

      const { accessToken } = TokenService.getAuth(store)

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return config
    },
    (error) => Promise.reject(error),
  )

  axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error) => {
      const config = error.config

      // NOTE: accessToken expired
      if (error.response?.status === 401 && !config?.sent) {
        config.sent = true

        // TODO: use memoized refresh
        const result = await TokenService.refresh(store)

        // NOTE: use just refreshed accessToken
        if (result?.accessToken) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${result.accessToken}`,
          }
        }

        return axios(config)
      } else if (error?.response?.status === 422) {
        return Promise.resolve(error.response)
      }

      return Promise.reject(error)
    },
  )
}

export const API = axios
